import {
  createContext,
  useContext,
  ReactNode, useMemo,
} from 'react';
import { toast, ToastContainer } from 'react-toastify';

export enum ToastType {
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  DEFAULT = 'default',
}

export type ToastContextType = {
  toastNotify: (toastType: ToastType, toastMessage: string) => void;
};

const ToastContext = createContext<ToastContextType>({} as ToastContextType);

export function useToast() {
  return useContext(ToastContext);
}

interface ToastProviderProps {
  children?: ReactNode;
}

export const ToastProvider = ({ children = undefined }: ToastProviderProps) => {
  const toastNotify = (toastType: ToastType, toastMessage: string) => {
    toast(toastMessage, {
      type: toastType,
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
      theme: 'light',
    });
  };

  const contextValue = useMemo(() => ({
    toastNotify,
  }), []);

  return (
    <ToastContext.Provider value={contextValue}>
      <ToastContainer />
      {children}
    </ToastContext.Provider>
  );
};
